export type HubNavId =
  "accueil" | "services" | "indicateurs" | "collecte" | "rapport" | "administration";

export type HubNavItem = {
  readonly id: HubNavId;
  readonly labelKey: `hub.nav.${HubNavId}`;
  /** In-app route (NavLink). */
  readonly path?: string;
  /** External / static asset link (e.g. PDF download). */
  readonly href?: string;
  readonly download?: string;
  readonly end?: boolean;
};

/** Labels aligned with the monitoring-hub design template (via i18n). */
export const HUB_NAV: readonly HubNavItem[] = [
  { id: "accueil", path: "/hub", labelKey: "hub.nav.accueil", end: true },
  { id: "services", path: "/hub/services", labelKey: "hub.nav.services" },
  { id: "indicateurs", path: "/hub/indicateurs", labelKey: "hub.nav.indicateurs" },
  { id: "collecte", path: "/hub/collecte", labelKey: "hub.nav.collecte" },
  { id: "rapport", path: "/hub/rapport", labelKey: "hub.nav.rapport" },
  { id: "administration", path: "/settings", labelKey: "hub.nav.administration" },
];
